
import { FunctionComponent, useEffect, useState } from 'react';
import styles from "./Section1.module.css";

import VortexWhite from '../AceternityUI/vortexWhite';
import { Link } from 'react-router-dom';
import SparklesCore from '../AceternityUI/3D-cardEffect/sparkle';


const Section1: FunctionComponent = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
	useEffect(() => {
		const elements = document.querySelectorAll('.text-animate');
		if (elements.length > 0) {
			animateText(elements);
		}
	}, []); // Run on mount

	return (
		// <div className={styles.frameParent} ref={sectionRef}></div>
		<div className={styles.frameParent} style={{ paddingTop: '130px' }}>
			<div className={styles.frameGroup}>
				<div className={styles.frameContainer}>
					<div className={styles.frameDiv}>
						<div className={styles.nextGenParent}>
							<div className={`${styles.nextGen} `}>
								<span>NEXT GEN</span>
							</div>
							<div className={`${styles.nextGen1} `}>
								<span>NEXT GEN</span>
							</div>
							<div className={`${styles.nextGen2}`}>
								<span>NEXT GEN</span>
							</div>
						</div>
						<div >
						{isMobile ? (
		<div style={{marginTop:"-120px"}}>					
  <SparklesCore />
  </div>
) : (
  <div className="vortexWrapper">
    <VortexWhite />
  </div>
)}

						</div>
						<div className={styles.collectionInfrastructure}>
							Collection Infrastructure
						</div>

					</div>
					<div className={styles.collectionInfrastructureTo}>AI-Powered Collection Beyond Automation at every step of your debt collection journey. One Powerful and Intelligent Platform Built for Maximum Recovery</div>
				</div>


				<div className={styles.overlayoverlayblur} />
				<div className={styles.buttonbg} style={{ cursor: 'pointer', border: "4px solid #61718e ", marginTop: "-50px" }}>
					{/* <div className={styles.contactSales} style={{marginRight:"-8px"}}>Get in touch</div> */}
					<div className={styles.contactSales} >
						<Link onClick={() => window.scrollTo(0, 0)} to="/contact-sales" style={{ textDecoration: "none", color: "inherit" }}>
							Get in touch
						</Link>
					</div>
					<img className={styles.arrowRightIcon1} style={{ marginRight: "-15px" }} alt="" src="./assets/arrow.svg" />
				</div>
			</div>
			<div className={styles.frameParent1}>
				{/* <div className={styles.frameWrapper}>
					<div className={styles.workflowAutomationParent}>
						<div className={styles.workflowAutomation}>Workflow</div>
						<img className={styles.arrowRightIcon1} alt="" src="./assets/arrow-right.png" />
					</div>
				</div> */}
				{/* <div className={styles.frameWrapper1}>
					<div className={styles.workflowAutomationGroup}>
						<div className={styles.workflowAutomation1}>Automation</div>
						<img className={styles.arrowRightIcon2} alt="" src="./assets/arrow-right.png" />
					</div>
				</div> */}
				{/* <div className={styles.frameWrapper2}>
					<div className={styles.workflowAutomationParent}>
						<div className={styles.workflowAutomation}>done</div>
						<img className={styles.arrowRightIcon1} alt="" src="./assets/arrow-right.png" />
					</div>
				</div> */}
				{/* <div className={styles.frameWrapper3}>
					<div className={styles.workflowAutomationGroup}>
						<div className={styles.workflowAutomation1}>but</div>
						<img className={styles.arrowRightIcon2} alt="" src="./assets/arrow-right.png" />
					</div>
				</div> */}
				{/* <div className={styles.frameWrapper4}>
					<div className={styles.workflowAutomationParent2}>
						<div className={styles.workflowAutomation4}>good</div>
						<img className={styles.arrowRightIcon5} alt="" src="./assets/arrow-right.png" />
					</div>
				</div> */}
			</div>
		</div>);
};

export default Section1;
function animateText(elements: NodeListOf<Element>) {
	throw new Error('Function not implemented.');
}

